import { Component } from '@angular/core';

@Component({
    selector: 'floori-card',
    standalone: true,
    imports: [],
    templateUrl: './floori-card.component.html',
    styleUrl: './floori-card.component.scss'
})
export class FlooriCardComponent {}
